(function ($) {

    // Content product - change image on color variation hover

    var current_name = ""

    function switch_variation() {
        let variation_data = $(this).data("product"),
                $variation_content = $(this).closest(".product-card-wrapper-js").find(".product-card")

        // If variation data is not set
        if (!variation_data) {
            return;
        }

        // Set as active
        $(this).siblings(".current").removeClass("current")
        $(this).addClass("current")

        // Switch content
        if (variation_data.content) {
            $variation_content.replaceWith(variation_data.content)
        }

        // Switch name
        if (variation_data.title) {
            current_name = variation_data.title
        }

        $(document).trigger("product_variation_switched")
    }

    function init_variations() {
        $(".product-card-linked-products__item").click(switch_variation); // bind event again
    }

    $(document).gp_ready(init_variations);

})(jQuery);